import { AnnouncementService } from '@/app/platform/platform-data/services/types';
import { Announcement } from '@/app/platform/platform-data/models/announcement';
import { AsyncResult } from '@common/result/asyncResult';
import { PlatformAnnouncementService } from '@data/_generated-api/platform-api/services/platform-announcement.service';
import { err, ok } from '@common/result/Result';
import Morphism from 'morphism';
import { Injectable } from '@angular/core';
import { dateTimeFormats } from '@shared/constants/dateTimeFormats';

@Injectable({
  providedIn: 'root'
})
export class AnnouncementApiService implements AnnouncementService {
  constructor(private readonly service: PlatformAnnouncementService) {}

  async create(model: Announcement): AsyncResult<Announcement> {
    const result = await this.service
      .postNotificationsAnnouncements({
        body: {
          key: model.key,
          level: Number(model.level),
          message: model.message,
          title: model.title,
          show: Number(model.show),
          showFrom: model.showFrom?.format(dateTimeFormats.offset3Precision),
          showTo: model.showTo?.format(dateTimeFormats.offset3Precision)
        }
      })
      .toPromise();

    if (!result.isValid) {
      return err();
    }
    const m = Morphism.map(Announcement, result.value);
    return ok(m);
  }

  async delete(model: Announcement): AsyncResult<Announcement> {
    const result = await this.service
      .deleteNotificationsAnnouncements({
        body: {
          id: model.deleteKey
        }
      })
      .toPromise();
    if (!result.isValid) {
      return err();
    }
    const m = Morphism.map(Announcement, result.value);
    return ok(m);
  }

  async getAll(): AsyncResult<Announcement[]> {
    const result = await this.service
      .postNotificationsAnnouncementsQueryDatasource({
        body: {}
      })
      .toPromise();

    if (!result.isValid) {
      return err();
    }

    const m = Morphism.map(Announcement, result.value.items);

    return ok(m);
  }

  async update(model: Announcement): AsyncResult<Announcement> {
    const result = await this.service
      .putNotificationsAnnouncements({
        body: {
          key: model.key,
          level: Number(model.level),
          message: model.message,
          title: model.title,
          id: model.id,
          show: Number(model.show),
          showFrom: model.showFrom?.format(dateTimeFormats.offset3Precision),
          showTo: model.showTo?.format(dateTimeFormats.offset3Precision)
        }
      })
      .toPromise();

    if (!result.isValid) {
      return err();
    }

    const m = Morphism.map(Announcement, result.value);
    return ok(m);
  }
}
